goog.provide("shadow.js.shim.module$$embedpdf$react$annotation");
goog.provide("module$shadow_js_shim_module$$embedpdf$react$annotation");
shadow.js.shim.module$$embedpdf$react$annotation = shadow.js.nativeProvides["@embedpdf/react/annotation"] = shadow$bridge("@embedpdf/react/annotation");
module$shadow_js_shim_module$$embedpdf$react$annotation.default = shadow.js.shim.module$$embedpdf$react$annotation;
